const makeArray = (obj) => {
    if (Array.isArray(obj)) {
        return obj;
    }
    else if (obj === undefined || obj === null) {
        return [];
    }
    else {
        return [obj];
    }
};
const VALIDATION_ERROR_NAME = 'ValidationError';
export class ValidationError extends Error {
    constructor(message, validationErrors, method, route) {
        validationErrors = makeArray(validationErrors);
        let details;
        if (validationErrors.length > 1) {
            details = 'Multiple Errors';
        }
        else {
            details = validationErrors[0];
        }
        if (details) {
            message = `${message}: ${details}`;
        }
        super(message);
        this.name = VALIDATION_ERROR_NAME;
        this.validationErrors = validationErrors;
        this.method = method;
        this.route = route;
        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
ValidationError.NAME = VALIDATION_ERROR_NAME;
//# sourceMappingURL=ValidationError.js.map